import React from 'react'
import Navbar from "../components/Navbar/Navbar"
import SignupForm from "../components/SignupForm/SignupForm"
import Footer from "../components/Footer/Footer"
import PageHeader from '../components/PageHeader/PageHeader'

function Signup() {
  return (
    <>
<Navbar/>
<SignupForm/>
<Footer/>
    </>  )
}

export default Signup